import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class ReportFilterVm {
	monthYearString?: string;
	wattages?: any;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'monthYearString': new UntypedFormControl(null, [...(validators['monthYearString'] ?? []), ...[]]),
			'wattages': new UntypedFormControl([], [...(validators['wattages'] ?? []), ...[Validators.required]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): ReportFilterVmFromFg {
		return new ReportFilterVmFromFg(fg);
	}
}

export class ReportFilterVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get monthYearString(): string {
		return this.fg.get('monthYearString').value;
	}
	set monthYearString(val) {
		this.fg.get('monthYearString').setValue(val);
	}
}
